import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { AccordionSection } from './AccordionSection';

const defaultItem = {
  title: 'Example Item',
  content: '<p>Example content. Edit me!</p>',
  isInitiallyOpen: false,
} as const;

export default createBuilderModule(
  withTracking(AccordionSection, {
    as: 'section',
    sectionName: SectionName.AccordionSection,
  }),
  {
    name: 'AccordionSection',
    image: 'https://cdn.zappy.app/6382a6105475561a2f092b12a8806891.png',
    inputs: [
      {
        name: 'heading',
        type: 'string',
        defaultValue: 'Section Heading',
      },
      {
        name: 'items',
        type: 'list',
        subFields: [
          {
            name: 'title',
            type: 'string',
            defaultValue: 'Item Title',
          },
          {
            name: 'content',
            type: 'richText',
            defaultValue: '<p>Example content. Edit me!</p>',
          },
          {
            name: 'href',
            type: 'string',
            helperText:
              'Optional link, visible as icon next to/under (depends on viewport) the content when open.',
          },
          {
            name: 'isInitiallyOpen',
            type: 'boolean',
            defaultValue: false,
            helperText:
              'Begin the accordion item as "open" (default to "closed until opened")',
          },
        ],
        defaultValue: [
          defaultItem,
          {
            ...defaultItem,
            title: 'Another Example Item',
          },
        ],
      },
      {
        name: 'seeMoreHref',
        type: 'string',
        helperText:
          'Optional link to "more entries". Adds button below Accordion entries.',
      },
      {
        name: 'seeMoreText',
        type: 'string',
        helperText: 'Text to display in the button linking to "more entries".',
      },
    ],
  },
);
